/**
 *
 * Asynchronously loads the component for Sap004
 * Author: July
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
